import logo from './logo.svg';
import './App.css';
import Chatbot from './Chatbot';
//import {withCookies,useCookies } from "react-cookie";
import { instanceOf } from 'prop-types';
import React, { useState } from "react";



import { withCookies, Cookies } from "react-cookie";
import PropTypes from "prop-types";

// Main component wrapped with withCookies HOC
function App({ cookies }) {
  const [name, setName] = useState(cookies.get("session") || "");
  const getCookie = (name) => {
      const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      return match ? decodeURIComponent(match[2]) : null;
  }
  // Save cookie
  const saveCookie = () => {
    if (!name.trim()) {
      alert("Name cannot be empty");
      return;
    }
    cookies.set("session", name, { path: "/", maxAge: 3600 }); // expires in 1 hour
    alert(`Cookie saved: username=${name}`);
  };

  // Remove cookie
  const removeCookie = () => {
    cookies.remove("session", { path: "/" });
    setName("");
    alert("Cookie removed");
  };
  return (<div className="App">
            <Chatbot />
        </div>);

}

App.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};
export default withCookies(App);
/*
class App extends Component {
static propTypes = {cookies: instanceOf(useCookies).isRequired};
constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = { session: cookies.get('session') || 'Guest' };
}

handleSetCookie = () => {
const { cookies } = this.props;
const threadid="user_id"+String(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000);
cookies.setCookie('session', threadid, { path: '/',maxAge: 3600,secure: true,sameSite: "strict" });
this.setState({ session: threadid });
console.log('Status:', "Cookie set successfully! value="+threadid);
};
handleGetCookie = (name) => {
const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
return match ? decodeURIComponent(match[2]) : null;
};

render() {
const { session } = this.state;
return (<div className="App">
            <Chatbot />
        </div>);
}
}
export default withCookies(App);


function App() {



  return (<div className="App">
            <Chatbot />
        </div>);

}

export default App;

*/